module.exports = __webpack_public_path__ + "static/media/bitmap-06@3x.7d4dce01.jpg";